import { render, staticRenderFns } from "./RecurrentPetitionersTable.vue?vue&type=template&id=51152f75"
import script from "./RecurrentPetitionersTable.vue?vue&type=script&lang=js"
export * from "./RecurrentPetitionersTable.vue?vue&type=script&lang=js"
import style0 from "./RecurrentPetitionersTable.vue?vue&type=style&index=0&id=51152f75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports